/* Erwal favorieten — hartje op elke productkaart, teller in de header en
   de lijst op /pages/favorieten. Bewaard per browser (localStorage), er
   gaat niets naar de server. De hartjes worden hier ingespoten in plaats
   van in de Liquid-kaart: zo werken ze op élke kaart (collectie, zoeken,
   aanbevelingen) en overleven ze de ajax-hertekening van de filters — een
   MutationObserver verft nieuwe kaarten bij. */

const SLEUTEL = 'erwal-favorieten';

const HART =
  '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5S3.5 15.8 3.5 9.9C3.5 7 5.7 5 8.2 5c1.8 0 3.2 1 3.8 2 .6-1 2-2 3.8-2 2.5 0 4.7 2 4.7 4.9 0 5.9-8.5 10.6-8.5 10.6z"/></svg>';

function lees() {
  try {
    const v = JSON.parse(localStorage.getItem(SLEUTEL));
    return Array.isArray(v) ? v.filter((x) => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

function bewaar(lijst) {
  try {
    localStorage.setItem(SLEUTEL, JSON.stringify(lijst));
  } catch {
    /* privémodus of vol — hartjes werken dan alleen niet blijvend */
  }
}

function wissel(handle) {
  const lijst = lees();
  const i = lijst.indexOf(handle);
  const toegevoegd = i < 0;
  if (toegevoegd) lijst.push(handle);
  else lijst.splice(i, 1);
  bewaar(lijst);
  return toegevoegd;
}

/* Vlieganimatie naar het header-hartje bij bewaren — zelfde soort
   feedback als de winkelwagen. Puur decor: bij reduced-motion of een
   ontbrekende headerknop gebeurt er gewoon niets. */
function vlieg(vanaf) {
  try {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const doel = document.querySelector('.erwal-fav-link');
    if (!doel || !vanaf) return;
    const a = vanaf.getBoundingClientRect();
    const b = doel.getBoundingClientRect();
    if (!a.width || !b.width) return;

    const hart = document.createElement('div');
    hart.className = 'erwal-fav-vlieg';
    hart.innerHTML = HART;
    hart.style.left = a.left + a.width / 2 - 13 + 'px';
    hart.style.top = a.top + a.height / 2 - 13 + 'px';
    document.body.append(hart);

    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        hart.style.transform = `translate(${dx}px, ${dy}px) scale(0.35)`;
        hart.style.opacity = '0';
      });
    });

    const klaar = () => {
      hart.remove();
      doel.classList.add('erwal-fav-pop');
      setTimeout(() => doel.classList.remove('erwal-fav-pop'), 450);
    };
    hart.addEventListener('transitionend', klaar, { once: true });
    setTimeout(klaar, 800);
  } catch {
    /* decor mag nooit de klik breken */
  }
}

function handleUitKaart(kaart) {
  const a = kaart.querySelector('a[href*="/products/"]');
  if (!a) return null;
  const m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
  return m ? m[1] : null;
}

/* 18 sep 2026: alleen schrijven als er echt iets verandert. Elke attribuut- of
   tekstwijziging is een DOM-mutatie, en de waarnemer onderaan reageert op
   mutaties: blind terugschrijven maakte een lus (waarnemer → verfHartjes/teller
   → mutatie → waarnemer …) die op élke pagina 6-7 keer per seconde doorliep. */
function zetStand(knop, aan) {
  const gewenst = aan ? 'true' : 'false';
  if (knop.getAttribute('aria-pressed') !== gewenst) knop.setAttribute('aria-pressed', gewenst);
  const label = aan ? 'Verwijder uit favorieten' : 'Bewaar als favoriet';
  if (knop.getAttribute('aria-label') !== label) knop.setAttribute('aria-label', label);
  if (knop.title !== label) knop.title = label;
}

function teller() {
  const n = lees().length;
  const tekst = String(n);
  document.querySelectorAll('.erwal-fav-teller').forEach((t) => {
    if (t.textContent !== tekst) t.textContent = tekst;
    if (t.hidden !== (n === 0)) t.hidden = n === 0;
  });
}

/* Hartjes op productkaarten zetten/bijwerken. Idempotent en goedkoop. */
function verfHartjes() {
  const lijst = lees();
  document.querySelectorAll('product-card').forEach((kaart) => {
    const galerij = kaart.querySelector('.card-gallery');
    if (!galerij) return;
    const handle = handleUitKaart(kaart);
    if (!handle) return;
    let knop = galerij.querySelector('.erwal-fav');
    if (!knop) {
      knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'erwal-fav';
      knop.innerHTML = HART;
      knop.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const toegevoegd = wissel(handle);
        if (toegevoegd) vlieg(knop);
        else favWeg(handle);
        verfHartjes();
        teller();
      });
      galerij.appendChild(knop);
    }
    zetStand(knop, lijst.includes(handle));
  });
  /* Knop op de productpagina (6 sep 2026): zelfde lijst, eigen opmaak. */
  document.querySelectorAll('.erwal-fav-product[data-handle]').forEach((knop) => {
    const handle = knop.dataset.handle;
    if (!handle) return;
    if (!knop.dataset.klaar) {
      knop.dataset.klaar = '1';
      knop.addEventListener('click', (e) => {
        e.preventDefault();
        const toegevoegd = wissel(handle);
        if (toegevoegd) vlieg(knop);
        verfHartjes();
        teller();
      });
    }
    const aan = lijst.includes(handle);
    zetStand(knop, aan);
    const tekst = knop.querySelector('.erwal-fav-product__tekst');
    if (tekst) tekst.textContent = aan ? 'In je favorieten' : 'Bewaar als favoriet';
  });
}

/* ---- lijst op /pages/favorieten ------------------------------------ */
/* Herzien 7 sep 2026: geen eigen kaartopmaak meer. De hulpsectie
   erwal-fav-kaarten (templates/search.json) levert via de Section Rendering
   API dezelfde productkaarten als de collectiepagina; hier alleen ophalen,
   sorteren en de kolomschakelaar (zelfde sessionStorage-sleutel als de
   collectiepagina, dus die keuze loopt mee). */

const SORTEER_SLEUTEL = 'erwal-favorieten-sorteer';
const WEERGAVE_SLEUTEL = 'product-grid-view-mobile';
let favKaarten = [];

function favVak() {
  return document.getElementById('erwal-favorieten-lijst');
}

function sessie(sleutel, standaard) {
  try {
    return sessionStorage.getItem(sleutel) || standaard;
  } catch {
    return standaard;
  }
}

function bewaarSessie(sleutel, waarde) {
  try {
    sessionStorage.setItem(sleutel, waarde);
  } catch {
    /* geen sessie-opslag: keuze geldt dan alleen nu */
  }
}

function toonAantal(n) {
  const balk = document.getElementById('erwal-favorieten-balk');
  if (!balk) return;
  balk.hidden = n === 0;
  const a = balk.querySelector('[data-efav-aantal]');
  const w = balk.querySelector('[data-efav-aantal-woord]');
  if (a) a.textContent = String(n);
  if (w) w.textContent = n === 1 ? 'product' : 'producten';
}

function gesorteerd(keuze) {
  const lijst = [...favKaarten];
  const coll = new Intl.Collator('nl');
  switch (keuze) {
    case 'prijs-op':
      lijst.sort((a, b) => a.prijs - b.prijs || coll.compare(a.titel, b.titel));
      break;
    case 'prijs-af':
      lijst.sort((a, b) => b.prijs - a.prijs || coll.compare(a.titel, b.titel));
      break;
    case 'naam':
      lijst.sort((a, b) => coll.compare(a.titel, b.titel));
      break;
    default:
      lijst.sort((a, b) => b.volgorde - a.volgorde);
  }
  return lijst;
}

function tekenKaarten() {
  const grid = favVak()?.querySelector('.product-grid');
  if (!grid) return;
  const keuze = sessie(SORTEER_SLEUTEL, 'nieuw');
  gesorteerd(keuze).forEach((k) => grid.appendChild(k.li));
  const sel = document.querySelector('[data-efav-sorteer]');
  if (sel && sel.value !== keuze) sel.value = keuze;
}

function zetWeergave(stand) {
  const grid = favVak()?.querySelector('.product-grid');
  if (grid) grid.setAttribute('product-grid-view', stand);
  document.querySelectorAll('input[name="efav-grid-mobile"]').forEach((i) => {
    i.checked = i.value === stand;
  });
}

function koppelBalk() {
  const sel = document.querySelector('[data-efav-sorteer]');
  if (sel && !sel.dataset.klaar) {
    sel.dataset.klaar = '1';
    sel.value = sessie(SORTEER_SLEUTEL, 'nieuw');
    sel.addEventListener('change', () => {
      bewaarSessie(SORTEER_SLEUTEL, sel.value);
      tekenKaarten();
    });
  }
  document.querySelectorAll('input[name="efav-grid-mobile"]').forEach((i) => {
    if (i.dataset.klaar) return;
    i.dataset.klaar = '1';
    i.addEventListener('change', () => {
      if (!i.checked) return;
      bewaarSessie(WEERGAVE_SLEUTEL, i.value);
      zetWeergave(i.value);
    });
  });
}

/* Hartje uitgezet op de favorietenpagina zelf: kaart meteen weg. */
function favWeg(handle) {
  const vak = favVak();
  if (!vak) return;
  const li = vak.querySelector('li[data-handle="' + CSS.escape(handle) + '"]');
  if (li) li.remove();
  favKaarten = favKaarten.filter((k) => k.handle !== handle);
  toonAantal(favKaarten.length);
  if (!favKaarten.length) bouwLijst();
}

/* De Section Rendering API wil bij JSON-templates de volledige sectie-id
   (template--<nummer>__erwal_fav_kaarten); dat nummer verschilt per thema.
   Een keer opzoeken in de zoekpagina en per thema onthouden. */
async function sectieId(vak, opnieuw) {
  const naam = vak.dataset.sectie || 'erwal_fav_kaarten';
  if (naam.startsWith('template--')) return naam;
  const themaId = (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || 'x';
  const sleutel = 'erwal-fav-sectie:' + themaId;
  if (!opnieuw) {
    try {
      const bekend = localStorage.getItem(sleutel) || '';
      if (bekend.endsWith('__' + naam)) return bekend;
    } catch {
      /* geen opslag: dan elke keer opzoeken */
    }
  }
  const r = await fetch('/search?q=erwal-fav&type=product', { headers: { Accept: 'text/html' } });
  if (!r.ok) throw new Error('zoekpagina ' + r.status);
  const html = await r.text();
  const m = html.match(new RegExp('shopify-section-(template--[^"\'\\s]+?__' + naam + ')'));
  if (!m) throw new Error('sectie niet gevonden');
  try {
    localStorage.setItem(sleutel, m[1]);
  } catch {
    /* geen opslag */
  }
  return m[1];
}

async function haalKaarten(handles, sectie) {
  const q = 'erwal-fav ' + handles.join(' ');
  const url = '/search?type=product&section_id=' + encodeURIComponent(sectie) + '&q=' + encodeURIComponent(q);
  const r = await fetch(url, { headers: { Accept: 'text/html' } });
  if (!r.ok) throw new Error('kaarten ' + r.status);
  return new DOMParser().parseFromString(await r.text(), 'text/html');
}

async function bouwLijst() {
  const vak = favVak();
  if (!vak) return;
  const leeg = document.getElementById('erwal-favorieten-leeg');
  const handles = lees();

  if (!handles.length) {
    vak.hidden = true;
    vak.innerHTML = '';
    favKaarten = [];
    toonAantal(0);
    if (leeg) leeg.hidden = false;
    return;
  }
  if (leeg) leeg.hidden = true;
  vak.hidden = false;
  vak.setAttribute('aria-busy', 'true');

  const brokken = [];
  for (let i = 0; i < handles.length; i += 20) brokken.push(handles.slice(i, i + 20));

  let wrapper = null;
  let stijlen = [];
  const gevonden = new Map();
  try {
    let docs;
    try {
      const id = await sectieId(vak, false);
      docs = await Promise.all(brokken.map((b) => haalKaarten(b, id)));
    } catch {
      /* onthouden id verlopen (ander thema, template opnieuw aangemaakt): een keer opnieuw opzoeken */
      const id = await sectieId(vak, true);
      docs = await Promise.all(brokken.map((b) => haalKaarten(b, id)));
    }
    docs.forEach((doc) => {
      const w = doc.querySelector('#ResultsList');
      if (!w) return;
      w.querySelectorAll('li[data-handle]').forEach((li) => gevonden.set(li.dataset.handle, li));
      if (!wrapper) {
        wrapper = w;
        /* De kolomregels van de grid (product-grid-snippet, per sectie-id)
           staan als <style> naast #ResultsList; die moeten mee. */
        stijlen = [...doc.querySelectorAll('style')];
      }
    });
  } catch {
    /* netwerkfout: laat staan wat er staat, niets uit de lijst gooien */
    vak.removeAttribute('aria-busy');
    return;
  }
  if (!wrapper) {
    vak.removeAttribute('aria-busy');
    return;
  }

  const verdwenen = handles.filter((h) => !gevonden.has(h));
  if (verdwenen.length) {
    bewaar(lees().filter((h) => !verdwenen.includes(h)));
    teller();
  }

  wrapper.querySelectorAll('script').forEach((s) => s.remove());
  const grid = wrapper.querySelector('.product-grid');
  if (!grid) {
    vak.removeAttribute('aria-busy');
    return;
  }
  grid.innerHTML = '';
  favKaarten = handles
    .filter((h) => gevonden.has(h))
    .map((h, i) => {
      const li = document.adoptNode(gevonden.get(h));
      return { handle: h, li, prijs: Number(li.dataset.prijs) || 0, titel: li.dataset.titel || '', volgorde: i };
    });
  vak.replaceChildren(...stijlen.map((s) => document.adoptNode(s)), document.adoptNode(wrapper));
  koppelBalk();
  tekenKaarten();
  zetWeergave(sessie(WEERGAVE_SLEUTEL, 'default'));
  toonAantal(favKaarten.length);
  verfHartjes();
  vak.removeAttribute('aria-busy');
}

/* ---- start ---------------------------------------------------------- */

function alles() {
  verfHartjes();
  teller();
  bouwLijst();
}

/* Alleen bijverven als er productkaarten of tellers bij zijn gekomen (nieuwe
   sectie na een filterwissel, zachte navigatie, aanbevelingen). Attribuut- en
   tekstwijzigingen — ook onze eigen — negeren we. */
let wachter = 0;
const isRelevant = (node) =>
  node instanceof Element &&
  !node.matches('.erwal-fav') &&
  (node.matches('product-card, .erwal-fav-teller, .erwal-fav-product') ||
    node.closest('product-card') !== null ||
    node.querySelector('product-card, .erwal-fav-teller, .erwal-fav-product') !== null);
new MutationObserver((muts) => {
  let relevant = false;
  for (const m of muts) {
    for (const n of m.addedNodes) {
      if (isRelevant(n)) { relevant = true; break; }
    }
    if (relevant) break;
  }
  if (!relevant) return;
  clearTimeout(wachter);
  wachter = setTimeout(() => {
    verfHartjes();
    teller();
  }, 150);
}).observe(document.body, { childList: true, subtree: true });

/* Terug via bfcache: stand kan intussen op een andere pagina gewijzigd zijn. */
window.addEventListener('pageshow', alles);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', alles);
} else {
  alles();
}
